import { type RouteLocationRaw, type RouteRecordRaw } from 'vue-router'

import { useOrganisationStore } from '@/stores/organisations'

const LinkedBusinesses = () => import('@/pages/vision/LinkedBusinesses.vue')
const Cohorts = () => import('@/pages/vision/Cohorts.vue')
const DeforestationReports = () => import('@/pages/deforestation/DeforestationReports.vue')
const Invitations = () => import('@/pages/vision/Invitations.vue')

const AnalyticsSingleYear = () => import('@/pages/analytics/Vision/SingleYear.vue')
const AnalyticsTrends = () => import('@/pages/analytics/Vision/Trends.vue')
const AnalyticsSupplyChain = () => import('@/pages/analytics/Vision/SupplyChain.vue')
const AnalyticsCommodity = () => import('@/pages/analytics/Vision/Commodity.vue')
const AnalyticsEmissionsOverview = () => import('@/pages/analytics/Vision/EmissionsOverview.vue')

function isVisionOrgUser() {
  return true
}

function visionDeforestationAccessGuard(): boolean | RouteLocationRaw {
  const organisationStore = useOrganisationStore()
  if (organisationStore.currentOrg?.type !== 'vision') return true

  const availableSharingScopes =
    organisationStore.currentOrg.preferences?.visionOrg?.availableSharingScopes ?? []
  if (availableSharingScopes.includes('deforestation')) return true

  return { path: '/organisation', query: { tab: 'features' } }
}

export const visionOrgRoutes: RouteRecordRaw[] = [
  {
    path: '/linked-businesses',
    name: 'linked-businesses',
    component: LinkedBusinesses,
    beforeEnter: isVisionOrgUser,
    meta: {
      breadcrumbs: {
        name: 'Linked Businesses',
      },
    },
  },
  {
    path: '/cohorts',
    name: 'cohorts',
    component: Cohorts,
    beforeEnter: isVisionOrgUser,
    meta: {
      breadcrumbs: {
        name: 'Cohorts',
      },
    },
  },
  {
    path: '/deforestation-reports',
    name: 'deforestation-reports',
    component: DeforestationReports,
    beforeEnter: [isVisionOrgUser, visionDeforestationAccessGuard],
    meta: {
      breadcrumbs: {
        name: 'Deforestation Reports',
      },
    },
  },
  {
    path: '/invitations',
    name: 'invitations',
    component: Invitations,
    beforeEnter: isVisionOrgUser,
    meta: {
      breadcrumbs: {
        name: 'Invitations',
      },
    },
  },
  // analytics
  {
    path: '/vision-analytics',
    meta: {
      breadcrumbs: {
        name: 'Analytics',
      },
    },
    children: [
      {
        path: 'trends',
        name: 'vision-analytics-trends',
        component: AnalyticsTrends,
        meta: {
          breadcrumbs: {
            name: 'Trends Over Time',
          },
        },
      },
      {
        path: 'annual',
        name: 'vision-analytics-annual',
        component: AnalyticsSingleYear,
        meta: {
          breadcrumbs: {
            name: 'Annual Overview',
          },
        },
      },
      {
        path: 'supply-chain',
        name: 'vision-analytics-supply-chain',
        component: AnalyticsSupplyChain,
        meta: {
          breadcrumbs: {
            name: 'Supply Chain',
          },
        },
      },
      {
        path: 'commodity',
        name: 'vision-analytics-commodity',
        component: AnalyticsCommodity,
        meta: {
          breadcrumbs: {
            name: 'Commodity Explorer',
          },
        },
      },
      {
        path: 'emissions-overview',
        name: 'vision-analytics-emissions-overview',
        component: AnalyticsEmissionsOverview,
        meta: {
          breadcrumbs: {
            name: 'Emissions Overview',
          },
        },
      },
    ],
  },
]
